import { CheckboxListFormik } from '@strata/react-checkbox-list';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { remanageTreatment } from 'api/treatmentAPI';
import { handleError } from 'services/Error';

const Title = 'Remanage Patient Treatment';

const overrideBenefitCheckText = 'Override Benefit Check';

export const RemanageTreatmentDialog = ({
    isOpen,
    onClose,
    treatmentDetails = undefined,
    submitCallback,
}) => {
    const { treatmentId, payerId } = treatmentDetails ?? {};
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={Yup.object({
                overrideBenefitCheck: Yup.bool(),
            })}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await remanageTreatment({
                        payerId,
                        treatmentId,
                        overrideBenefitCheck: values.overrideBenefitCheck,
                    });

                    submitCallback();

                    SuccessToast({ message: 'Treatment remanaged successfully.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError('Unable to remanage treatment. Please try again.', err);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen={isOpen}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel={Title}
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action mimics submitting from the payer to our platform.
                            </div>
                            <CheckboxListFormik
                                name="overrideBenefitCheck"
                                options={[overrideBenefitCheckText]}
                                values={
                                    formik.values.overrideBenefitCheck
                                        ? [overrideBenefitCheckText]
                                        : []
                                }
                                onChange={(newValue) =>
                                    formik.setFieldValue(
                                        'overrideBenefitCheck',
                                        newValue.includes(overrideBenefitCheckText),
                                    )
                                }
                            />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

RemanageTreatmentDialog.Title = Title;

RemanageTreatmentDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentDetails: PropTypes.shape({
        treatmentId: PropTypes.string,
        payerId: PropTypes.string,
    }),
    submitCallback: PropTypes.func.isRequired,
};
